import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fetchAnnouncements,
  fetchPromotions,
  fetchInventories,
  fetchExpiringItems,
  fetchUnsalableItems,
  fetchPaginationBestsellers,
  fetchPageViews,
  fetchSearchKeywords,
  fetchSpecificSearchKeywordListings,
  fetchAbandonedCarts,
  fetchArrivalNoticeSummaries,
  fetchListingTags,
  fetchProductBundles,
  fetchListings,
  createSupplierCoupons,
  fetchNotifications
} from '../../app/actions'
import {
  setI13nData,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../app/actions/common'
import Item from '../components/Item/Item'

const mapStateToProps = (state, ownProps) => {
  return {
    supplier: state.supplier,
    page: state.page,
    env: state.page.env
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setI13nData,
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    fetchAnnouncements,
    fetchPromotions,
    fetchInventories,
    fetchExpiringItems,
    fetchUnsalableItems,
    fetchPaginationBestsellers,
    fetchPageViews,
    fetchSearchKeywords,
    fetchSpecificSearchKeywordListings,
    fetchAbandonedCarts,
    fetchArrivalNoticeSummaries,
    fetchListingTags,
    fetchProductBundles,
    fetchListings,
    createSupplierCoupons,
    fetchNotifications
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

Item.fetchData = ({ store, req, res }) => {
  const tasks = [
    // // 取得右方及上方宣傳版位上稿
    // APACSMDESK-20096 先關閉資料
    // store.dispatch(supplierActions.fetchPromotions({ id: ['SpHeaderTxt1', 'SpHomeRightImg1'] }))
  ]
  return Promise.all(tasks)
}

const MappedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Item)

export default MappedContainer
